export default __webpack_public_path__ + "static/media/7218-forsyth.5ef6479d.jpeg";